import { render, staticRenderFns } from "./CurrentPowerModule.vue?vue&type=template&id=61163dcc&scoped=true&"
import script from "./CurrentPowerModule.vue?vue&type=script&lang=js&"
export * from "./CurrentPowerModule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61163dcc",
  null
  
)

export default component.exports